import React, {ReactElement} from "react"
import styled from "styled-components"
import FilesNotFound from "./file-icons/NoFiles.svg"
import FoldersNotFound from './file-icons/NoFolder.svg'

interface Props {
	children: string
	folder?: boolean
	customLabel?: string
	fullView?: boolean
}

function EmptyDropboxContents(props: Props): ReactElement {
	const {children, folder = true, customLabel = '', fullView = false} = props
	return (
		<Container fullView={fullView}>
			<Wrapper>
				<img src={folder ? FoldersNotFound : FilesNotFound} alt={customLabel || folder ? 'Folders not found' : 'File not found'} />
				<Heading>{children}</Heading>
			</Wrapper>
		</Container>
	)
}

const Container = styled.div<{ fullView: boolean }>`
	display: flex;
	justify-content: center;
	align-items: center;
	width: 100%;
	${props => props.fullView && 'height: 100%;'}
`

const Wrapper = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	padding: 30px 0;

	img {
		width: 100px;
		height: 100px;
	}
`

const Heading = styled.div`
	margin-top: 8px;
	font-weight: 400;
	font-size: 13px;
`

export default EmptyDropboxContents
